import { apis } from '@doltech/core/lib/api/api.config';
import { apiUrls } from '@doltech/core/lib/api/api.urls';

export const updateUserTutorial = (params) =>
  apis.userService.put(apiUrls.userService.UPDATE_USER_TUTORIAL, params);
